/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import {
  Paper, Box, Typography, Grid, List,
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import IconButton from '@mui/material/IconButton';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import MenuIcon from '@mui/icons-material/Menu';
import { useHistory } from 'react-router-dom';
import mainListItems from './listItems/listItems';
import { LoginStore, LinksStore } from '../../services/zustandProvider';
import MobileDrawer from './mobileDrawer';
import logo from '../../assets/logo3.png';
import { Usuario } from '../../pages/models';

export default function Header() {
  const history = useHistory();
  const [showDrawer, setShowDrawer] = useState(false);
  const { Imagem } = LinksStore();
  const { Log, userAtivo, setUserAtivo } = LoginStore();
  async function logout() {
    localStorage.removeItem('ptt:User');
    localStorage.removeItem('ptt:Token');
    setUserAtivo(new Usuario());
    history.push('/Login');
  }
  return (
    <Box sx={{
      '& > :not(style)': {
        width: '100%',
        height: 100,
        position: 'fixed',
        zIndex: 99,
        top: 0,
        left: 0,
        marginBottom: 100,
        display: Log ? 'flex' : 'none',
      },
    }}
    >
      <MobileDrawer open={showDrawer} close={() => setShowDrawer(false)} />
      <Paper square elevation={0} sx={{ backgroundColor: '#4c5c68', alignItems: 'center', color: 'white' }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          sx={{ marginRight: '10px !important', marginLeft: '10px !important', display: { xs: 'block !important', sm: 'none !important' } }}
          onClick={() => setShowDrawer(true)}
          edge="start"
        >
          <MenuIcon />
        </IconButton>
        <GroupIcon sx={{
          fontSize: '50px',
          color: 'white',
          marginTop: '-15px',
          marginRight: { xs: '5px !important', sm: '20px !important' },
          marginLeft: { xs: '0px !important', sm: '20px !important' },
        }}
        />
        <Box sx={{ width: '50% !important', marginTop: { xs: '-25px', sm: '0px' } }}>
          <Typography sx={{
            fontSize: { xs: '4vw', sm: '2vw', xl: '1.5vw' },
            color: 'white',
            lineHeight: '0.9',
            fontWeight: 'bold !important',
          }}
          >
            Portal do
            {' '}
            <br />
            Titular de dados
          </Typography>
          <Grid
            container
            sx={{
              position: { xs: 'absolute', sm: 'relative' },
              marginTop: { xs: '-3px', sm: '0px' },
            }}
          >
            <Grid item xs={11} sm="auto" sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{
                fontSize: { xs: '2.5vw', sm: '0.8vw', xl: '0.8vw' },
                color: 'white',
              }}
              >
                { userAtivo?.nome }
              </Typography>
            </Grid>
            <Grid item sx={{ width: '10px', marginLeft: '8px' }}>
              |
            </Grid>
            <Grid item xs={12} sm="auto" sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{
                fontSize: { xs: '2.5vw', sm: '0.8vw', xl: '0.8vw' },
                color: 'white',
                textAlign: 'left',
              }}
              >
                { userAtivo?.email }
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <List sx={{
          margin: '0px', padding: 0, width: '100%', display: { xs: 'none', sm: 'block' },
        }}
        >
          {mainListItems('white')}
        </List>
        <Box sx={{
          display: 'flex', marginLeft: 'auto', alignItems: 'center', maxWidth: '30%',
        }}
        >
          <img
            src={`data:image;charset=utf-8;base64, ${Imagem}`}
            alt="logo"
            style={{
              marginLeft: 'auto',
              width: 'auto',
              maxHeight: 150,
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() => logout()}
        >
          <PowerSettingsNewIcon sx={{
            fontSize: '35px',
            color: 'white',
            marginRight: { xs: '5px !important', sm: '20px !important' },
            marginLeft: { xs: '0px !important', sm: '20px !important' },
          }}
          />
        </IconButton>
      </Paper>
    </Box>
  );
}
